import { render, staticRenderFns } from "./VuetifyDialog.vue?vue&type=template&id=5b19b9ba"
import script from "./VuetifyDialog.vue?vue&type=script&lang=js"
export * from "./VuetifyDialog.vue?vue&type=script&lang=js"
import style0 from "./VuetifyDialog.vue?vue&type=style&index=0&id=5b19b9ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports